module.exports = __webpack_public_path__ + "img/15.90f2e0c8.png";